export const PUBLIC_ROUTES = ["/auth/(.*)", "/"];

export const filterPaths = (
  routes,
  isAuthorized = true,
  publicRoutes = PUBLIC_ROUTES
) =>
  isAuthorized ? routes : routes.filter(r => publicRoutes.includes(r.path));
